import Select from 'meinian-package/src/baseComponent/select'
import TiledSelect from 'baseComponent/tiledSelect'
import { COMMON_PLATFORM_CONFIG_ENUM } from 'meinian-package/src/component/platformConfig'
import { useRequest } from 'ahooks'
import { request } from 'meinian-package/src/utils'

const getZKPlatformValue = (result = []) => {
  const ids = []
  result?.forEach(platform => {
    if (platform.platformType === '服装站点') {
      platform?.platformList?.forEach(item => {
        ids.push(item.platformId)
      })
    }
    if (platform?.platformType === '独立站') {
      ids.push(-999)
    }
  })
  return ids.join(',')
}

export default (props) => {
  const { value, onChange, placement, ulStyle, trigger } = props

  const { data = [] } = useRequest(async () => {
    const result = await request.get('/zhikuan/platform/mn-list-zk-platform')
    const platformOptions = COMMON_PLATFORM_CONFIG_ENUM.values().map(item => ({ ...item, value: String(item.value) }))
    return [...platformOptions,
      {
        label: '知款站点',
        value: getZKPlatformValue(result)
      }]
  })

  return <Select
    placement={placement}
    data={data}
    value={value}
    onChange={onChange}
    placeholder="款式来源"
    style={{ maxHeight: 'unset' }}
    ulStyle={ulStyle}
    trigger={trigger}
  />
}

export const TiledPlatform = ({ value, onChange, style, className }) => {
  const { data = [] } = useRequest(async () => {
    const result = await request.get('/zhikuan/platform/mn-list-zk-platform')
    const platformOptions = COMMON_PLATFORM_CONFIG_ENUM.values().map(item => ({ ...item, value: String(item.value) }))
    return [...platformOptions,
      {
        label: '知款站点',
        value: getZKPlatformValue(result)
      }]
  })

  return <TiledSelect
    label="款式来源"
    options={data}
    value={value}
    onChange={onChange}
    style={style}
    className={className}
  />
}
